import AsyncSelect from '@enerex/unified-ui-react/form/AsyncSelect';

const getDefaultOptionLabel = (option: any) => {
    if (option === null || option === undefined) {
        return '';
    }

    if (typeof option !== 'object') {
        return String(option);
    }

    return String(
        option.label ??
            option.name ??
            option.title ??
            option.value ??
            option.id ??
            ''
    );
};

const getDefaultOptionValue = (option: any) => {
    if (option === null || option === undefined) {
        return '';
    }

    if (typeof option !== 'object') {
        return String(option);
    }

    return String(
        option.value ??
            option.id ??
            option.name ??
            option.label ??
            option.title ??
            ''
    );
};

const UnifiedAsyncSelect = ({
    getOptionLabel = getDefaultOptionLabel,
    getOptionValue = getDefaultOptionValue,
    ...props
}: any) => (
    <AsyncSelect
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        {...props}
    />
);

export default UnifiedAsyncSelect;
